import React from 'react';
import styles from './CartItem.module.scss';
import currency from 'currency.js';
import Delete from '../../../icons/Delete';

export default function Extras({ orderPackage, removeItem, editable }) {
  return (
    <div className={styles.extrasWrapper}>
      {orderPackage.orderPackageExtras.map((orderPackageExtra) => {
        if (!orderPackageExtra.extra) return null;

        const priceWithout = orderPackageExtra.extra.prices[0].priceWithout;
        const priceWith = orderPackageExtra.extra.prices[0].price;
        const price = orderPackage.price === 0 && priceWithout ? priceWithout : priceWith;

        return (
          <div className={styles.extras}>
            <div className={styles.extra}>
              <div>{orderPackageExtra.extra.name}</div>
              <div>{currency(price).format()}</div>
            </div>
            {editable && (
              <div className={styles.grayscaled}>
                <Delete onClick={() => removeItem(orderPackageExtra.id, 'extras')}/>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
